export default __webpack_public_path__ + "static/media/Path3402.5c50b65e.svg";